export const sendForm = (context) => (id) => ({
    type: "CMS.FORMS.SEND",
    payload: { id },
    context,
});

export const clearForms = (context) => () => ({
    type: "CMS.FORMS.CLEAR",
    context,
});
